import React from 'react';
import CheckboxInput from 'shared/components/CheckboxInput';
import Label from 'shared/components/Label';

const ControlledImpedance = (props) => {
  const name = 'controlled_impedance';

  const {
    parameters,
    onChangeParameter,
    groupName,
    label,
  } = props;

  const onChange = e => onChangeParameter(name, e.target.checked ? '1' : '0');

  const checked = parameters && parameters[name] === '1';

  return (
    <div className="text-nowrap">
      <CheckboxInput
        inputId={name}
        inputClassName="mr-2"
        name={name}
        groupName={groupName}
        checked={checked}
        onChange={onChange} />
      <Label htmlFor={name} label={label} />
    </div>
  );
};

ControlledImpedance.defaultProps = {
  label: Spree.translations.parameters.controlled_impedance,
  tooltip: Spree.helpForParameters.controlled_impedance,
};

export default ControlledImpedance;
